import { useTranslation } from 'react-i18next';
import { Tabs, TabsList, TabsTrigger } from '@/shared/components/ui/tabs';

const OVERVIEW_TABS = {
  wallets: 'wallets',
  tradingAccounts: 'tradingAccounts',
} as const;

type OverviewTab = keyof typeof OVERVIEW_TABS;

const TAB_TRIGGER_CLASSNAME =
  'h-[2.8rem] rounded-[0.8rem] px-[1.2rem] py-0 data-[state=active]:bg-secondary-bg data-[state=active]:shadow-none';

type Props = {
  value: OverviewTab;
  onValueChange: (value: OverviewTab) => void;
};

const OverviewTabs = ({ value, onValueChange }: Props) => {
  const { t } = useTranslation();

  return (
    <Tabs
      value={value}
      onValueChange={nextValue => onValueChange(nextValue as OverviewTab)}>
      <TabsList className="bg-transparent gap-[0.2rem] p-0 h-[2.8rem]">
        <TabsTrigger
          value={OVERVIEW_TABS.wallets}
          className={TAB_TRIGGER_CLASSNAME}>
          {t('personalAccount.overview.tabs.wallets')}
        </TabsTrigger>
        <TabsTrigger
          value={OVERVIEW_TABS.tradingAccounts}
          className={TAB_TRIGGER_CLASSNAME}>
          {t('personalAccount.overview.tabs.tradingAccounts')}
        </TabsTrigger>
      </TabsList>
    </Tabs>
  );
};

export { OverviewTabs, OVERVIEW_TABS, type OverviewTab };
